import { useTranslation } from '@blocs.i18n';
import { SizesChildrenCategoryEnum } from '../types';

export const useSizesChildrenCategoryOptions = () => {
  const { t } = useTranslation();

  return [
    { value: SizesChildrenCategoryEnum.boys, label: t('common:profile.sizes.boys') },
    { value: SizesChildrenCategoryEnum.girls, label: t('common:profile.sizes.girls') },
    { value: SizesChildrenCategoryEnum.toddlers, label: t('common:profile.sizes.toddlers') },
    { value: SizesChildrenCategoryEnum.infants, label: t('common:profile.sizes.infants') },
  ];
};
